import { render, staticRenderFns } from "./ProductDeleteModal.vue?vue&type=template&id=96189728&scoped=true"
import script from "./ProductDeleteModal.vue?vue&type=script&lang=js"
export * from "./ProductDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96189728",
  null
  
)

export default component.exports